import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/news", label: "影视资讯" },
  { to: "/about", label: "关于我们" },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-600 text-background-50 flex items-center justify-center">
              <i className="ri-bubble-chart-fill text-lg" />
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
              泡泡影视
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/search"
              className="hidden sm:flex items-center gap-2 h-9 pl-3 pr-4 rounded-full bg-background-100 border border-background-200 text-foreground-500 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-base" />
              <span className="text-sm whitespace-nowrap">搜索影视 / 资讯</span>
            </Link>
            <Link
              to="/search"
              aria-label="搜索"
              className="sm:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200 text-foreground-700 cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((open) => !open)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 border border-background-200 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 animate-fade-in">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}